module.exports = __webpack_public_path__ + "assets/images/img3x-59eced3c631da243fac98e9b6bee4b59.png";